import { createRoute } from '@tanstack/react-router';
import { PricingPage } from '@/features/stock/PricingPage';
import { Route as shellRoute } from '../_shell';

/** Source pricing: the quote list and the per SKU comparison against WAC. */
export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/stock/pricing',
  component: PricingPage,
});
